import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  deleteDataEmployeeApi,
  detailEmployeeApi,
  getEmployeeApi,
  getEmployeeReport,
  getEmployeeTemplate,
  postEmployee,
  updateEmployeeApi,
  uploadEmployeeApi,
} from "./employeeApi";

export const postEmployeeRequest = createAsyncThunk(
  "postEmployeeRequest/employee",
  async (payload: any) => {
    try {
      const response = await postEmployee(payload);
      return response;
    } catch (error) {}
  }
);

export const getEmployeeReportRequest = createAsyncThunk(
  "getEmployeeReportRequest/employee",
  async () => {
    try {
      const response = await getEmployeeReport();
      return response;
    } catch (error) {}
  }
);

export const getEmployeeTemplateRequest = createAsyncThunk(
  "getEmployeeTemplateRequest/employee",
  async () => {
    try {
      const response = await getEmployeeTemplate();
      return response;
    } catch (error) {}
  }
);

export const detailEmployeeRequest = createAsyncThunk(
  "detailEmployeeRequest/employee",
  async (payload: any) => {
    try {
      const response: any = await detailEmployeeApi(payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getEmployeeRequest = createAsyncThunk(
  "getEmployeeRequest/employee",
  async () => {
    try {
      const response: any = await getEmployeeApi();
      return response;
    } catch (error) {
      console.log(error);
    }
  }
);

export const uploadEmployeeRequest = createAsyncThunk(
  "uploadEmployeeRequest/employee",
  async (payload: any) => {
    console.log("PA", payload);

    try {
      const response = await uploadEmployeeApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const updateUploadEmployeeRequest = createAsyncThunk(
  "updateUploadEmployeeRequest/employee",
  async (payload: any) => {
    console.log("PA", payload);

    try {
      const response = await updateEmployeeApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const deleteDataEmployeeRequest = createAsyncThunk(
  "deleteDataEmployeeRequest/employee",
  async (payload: any) => {
    console.log("PA", payload);

    try {
      const response = await deleteDataEmployeeApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

interface IInitialStateEmp {
  listEmployeeTemplate: any;
  listEmployees: any[];
  postEmployeeData: any;
  message: string;
  pageIsLoading: boolean;
  detailEmployee: any;
  employeePersonList: any[];
  uploadEmployee: any;
  updateEmployee: any;
  isUploadFullField: boolean;
  isDeleted: boolean;
  deletedRes: any
}

const initialState: IInitialStateEmp = {
  listEmployeeTemplate: [],
  listEmployees: [],
  postEmployeeData: {},
  message: "",
  pageIsLoading: false,
  detailEmployee: {},
  employeePersonList: [],
  uploadEmployee: null,
  updateEmployee: null,
  isUploadFullField: false,
  isDeleted: false,
  deletedRes: null
};

const employeeSlice = createSlice({
  name: "employee",
  initialState: initialState,
  reducers: {
    resetMessageEmp: (state) => {
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(postEmployeeRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(postEmployeeRequest.fulfilled, (state, action) => {
      if (action.payload.status !== 1000) {
        state.message = action.payload.message;
        state.pageIsLoading = false;
      } else {
        state.postEmployeeData = action.payload.data;
        state.message = action.payload.message;
        state.pageIsLoading = false;
      }
    });
    builder.addCase(postEmployeeRequest.rejected, (state) => {
      state.message = "Post Employee Failed";
      state.pageIsLoading = false;
    });

    // get report employee
    builder.addCase(getEmployeeReportRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(getEmployeeReportRequest.fulfilled, (state, action) => {
      if (action.payload.status !== 1000) {
        state.message = action.payload.message;
        state.pageIsLoading = false;
      } else {
        state.listEmployees = action.payload.data;
        state.pageIsLoading = false;
      }
    });
    builder.addCase(getEmployeeReportRequest.rejected, (state) => {
      state.message = "failed get employees";
      state.pageIsLoading = false;
    });

    // employee template
    builder.addCase(getEmployeeTemplateRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(getEmployeeTemplateRequest.fulfilled, (state, action) => {
      if (action.payload.status !== 1000) {
        state.message = action.payload.message;
        state.pageIsLoading = false;
      } else {
        state.listEmployeeTemplate = action.payload.data;
        state.pageIsLoading = false;
      }
    });
    builder.addCase(getEmployeeTemplateRequest.rejected, (state) => {
      state.message = "failed get employees";
      state.pageIsLoading = false;
    });

    // detail employee
    builder.addCase(detailEmployeeRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(detailEmployeeRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.detailEmployee = action.payload.data;
        state.pageIsLoading = false;
      } else {
        state.message = "Someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(detailEmployeeRequest.rejected, (state) => {
      state.message = "Someting went wrong on server";
      state.pageIsLoading = false;
    });

    // get employee
    builder.addCase(getEmployeeRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(getEmployeeRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.employeePersonList = action.payload.data;
        state.pageIsLoading = false;
      } else {
        state.message = "Someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(getEmployeeRequest.rejected, (state) => {
      state.message = "Someting went wrong on server";
      state.pageIsLoading = false;
    });

    // uploadEmployee
    builder.addCase(uploadEmployeeRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(uploadEmployeeRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.uploadEmployee = action.payload.data;
        state.pageIsLoading = false;
        // state.isUploadFullField = true;
        // state.isSuccess = true;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(uploadEmployeeRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });

    // update Employee
    builder.addCase(updateUploadEmployeeRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(updateUploadEmployeeRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.updateEmployee = action.payload.data;
        state.pageIsLoading = false;
        // state.isUploadFullField = true;
        // state.isSuccess = true;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(updateUploadEmployeeRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });

    // delete Employee
    builder.addCase(deleteDataEmployeeRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(deleteDataEmployeeRequest.fulfilled, (state, action) => {
      console.log("DELETEEEE", action.payload);
      
      if (action.payload.status === 1000) {
        state.isDeleted = true;
        state.deletedRes = action.payload.data;
        state.pageIsLoading = false;
        state.message = action.payload.message
        // state.isUploadFullField = true;
        // state.isSuccess = true;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(deleteDataEmployeeRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });
  },
});

export const { resetMessageEmp } = employeeSlice.actions;
export default employeeSlice.reducer;
